/* eslint-disable react/jsx-filename-extension */
import App from "./App"
import store from "./redux/store"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import {
    BrowserRouter as Router, Route, Redirect, Switch
} from "react-router-dom"

const DefaultRoute = () => <Redirect to={`${process.env.REACT_APP_PROXY_PATH}/en`} />

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <Switch>
                    <Route
                        path={`${process.env.REACT_APP_PROXY_PATH}/:locale(en|sv)`}
                        component={App}
                    />
                    <Route component={DefaultRoute} />
                </Switch>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
)
